import { FC } from 'react';
import { Checkbox as MUICheckbox, CheckboxProps } from '@mui/material';
import './style.scss';
import { Controller, FieldValues, RegisterOptions } from 'react-hook-form';

const Checkbox: FC<CheckboxProps> = ({ className = '', ...rest }) => {
  return <MUICheckbox className={`common_check_box  ${className}`} {...rest} />;
};

export default Checkbox;

interface IControlledCheckbox {
  name: string;
  className?: string;
  disabled?: boolean;
  onChange?: (_checked: boolean) => void; // Modified to directly pass the checked state
  rules?: Omit<
    RegisterOptions<FieldValues, string>,
    'disabled' | 'setValueAs' | 'valueAsNumber' | 'valueAsDate'
  >;
}

export const ControlledCheckbox = ({
  name,
  rules,
  onChange,
  ...rest
}: IControlledCheckbox) => {
  return (
    <Controller
      name={name}
      rules={rules}
      render={({ field }) => {
        return (
          <Checkbox
            {...rest}
            {...field}
            checked={field.value}
            onChange={e => {
              field.onChange(e.target.checked);
              onChange?.(e.target.checked);
            }}
          />
        );
      }}
    />
  );
};
